// // import React, { Component } from "react";

// // import Backend from "../utils/Backend";
// // import Notify from "../utils/Notify";
// // import Currency from "../utils/Currency";
// // import General from "../utils/General";
// // import Event from "../utils/Event";

// // import StatsCard from "./components/stats-cards/StatsCard";
// // import MenuItemsTable from "./components/tables/MenuItemsTableV2";

// // import AddCategoryModal from "./components/modals/AddCategoryModal";
// // import PasscodeModal from "./components/modals/PasscodeModal";

// // import { PASSCODE_ICON_UPDATED } from "../constants/Events";

// // import VenueDepartments from "./components/venuedepartment/venuedepartments";

// // export default class ManageMenu extends Component {
// //   constructor(props) {
// //     super(props);

// //     this.state = {
// //       data: null,
// //       stats: null,
// //       selectedCategoryItem: null,
// //     };
// //   }

// //   componentDidMount() {
// //     this.setState(
// //       {
// //         passcode: JSON.parse(sessionStorage.getItem("passcodeKey")),
// //       },
// //       () => {
// //         this._getMenu();
// //       }
// //     );

// //     this._getStats();
// //     // console.log("passcode: ", JSON.parse(sessionStorage.getItem("passcodeKey")))
// //   }

// //   onClickTabItem(tab) {
// //     this.setState({ selectedCategoryItem: tab });
// //   }

// //   _getMenu() {
// //     let menuId = this.props.match.params.menuId;

// //     const { passcode } = this.state;

// //     this.setState({ isMenuDataLoading: true });

// //     if (!passcode) {
// //       return;
// //     }

// //     Backend.getMenu(menuId, passcode)
// //       .then((data) => {
// //         passcode &&
// //           sessionStorage.setItem("passcodeKey", JSON.stringify(passcode));

// //         // this.setState({ data, passcode, isMenuDataLoading: false });
// //         this.setState((previousState) => {
// //   const categories = data?.menu_categories || [];

// //   const selectionExists = categories.some(
// //     (item) =>
// //       String(item.category?.id) ===
// //       String(previousState.selectedCategoryItem)
// //   );

// //   return {
// //     data,
// //     passcode,
// //     isMenuDataLoading: false,
// //     selectedCategoryItem: selectionExists
// //       ? previousState.selectedCategoryItem
// //       : categories[0]?.category?.id ?? null,
// //   };
// // });

// //         Event.emit(PASSCODE_ICON_UPDATED, passcode);
// //       })
// //       .catch((error) => {
// //         Notify.error(error.message);
// //         this.setState({
// //           isMenuDataLoading: false,
// //           passcode: null,
// //         });
// //       });
// //   }

// //   // _showCategories() {
// //   //   let { data, selectedCategoryItem } = this.state;

// //   //   if (data?.menu_categories.length > 0) {
// //   //     selectedCategoryItem = data.menu_categories[0]?.category.id;
// //   //   }

// //   //   return data?.menu_categories?.map((categoryItem) => {
// //   //     return (
// //   //       <li className="nav-item mt-3" key={categoryItem?.category.id}>
// //   //         <a
// //   //           onClick={() => {
// //   //             this.onClickTabItem(categoryItem?.category?.id);
// //   //           }}
// //   //           className={`nav-link ${
// //   //             selectedCategoryItem === categoryItem?.category?.id
// //   //               ? "active"
// //   //               : ""
// //   //           }`}
// //   //           id="wine-tab"
// //   //           data-toggle="tab"
// //   //           href="wine"
// //   //           aria-controls="profile"
// //   //         >
// //   //           <span className="nav-text">
// //   //             {General.toTitleCase(categoryItem?.category?.title)}
// //   //           </span>
// //   //         </a>
// //   //       </li>
// //   //     );
// //   //   });
// //   // }


// //   _showCategories() {
// //   const { data, selectedCategoryItem } = this.state;

// //   return data?.menu_categories?.map((categoryItem) => {
// //     const category = categoryItem.category;

// //     return (
// //       <li className="nav-item mt-3" key={category.id}>
// //         <button
// //           type="button"
// //           role="tab"
// //           aria-selected={selectedCategoryItem === category.id}
// //           onClick={() => this.onClickTabItem(category.id)}
// //           className={`nav-link ${
// //             selectedCategoryItem === category.id ? "active" : ""
// //           }`}
// //         >
// //           <span className="nav-text">
// //             {General.toTitleCase(category.title)}
// //           </span>
// //         </button>
// //       </li>
// //     );
// //   });
// // }

// //   _getStats() {
// //     let venueId = this.props.match.params.menuId;

// //     this.setState({ isVenueDataLoading: true });

// //     Backend.getStats(venueId)
// //       .then((stats) => {
// //         this.setState({ stats, isVenueDataLoading: false });
// //       })
// //       .catch((error) => {
// //         Notify.error(error.message);
// //         this.setState({
// //           isVenueDataLoading: false,
// //         });
// //       });
// //   }

// //   render() {
// //     const { showAddCategoryModal, data, stats, passcode, showPasscodeModal } =
// //       this.state;

// //     if (!stats) {
// //       return null;
// //     }

// //     let categoryMenuItem = data?.menu_categories?.find(
// //       (categoryItem) =>
// //         categoryItem?.category?.id == this.state.selectedCategoryItem
// //     );

// //     let categoryId = categoryMenuItem?.category.id;

// //     let menuCategoryId = categoryMenuItem?.id;

// //     let menuId = this.props.match.params.menuId;

// //     // Pass venueId as a prop if it is not available in the route.
// //     const venueId =
// //   this.props.match.params.venueId ?? this.props.venueId;

// //     return (
// //       <>
// //         <div className="container">
// //           <div className="card card-custom gutter-b">
// //             <div className="card-header">
// //               <div className="card-title">
// //                 <span className="card-icon">
// //                   <span className="svg-icon svg-icon-primary svg-icon-2x">
// //                     <svg
// //                       xmlns="http://www.w3.org/2000/svg"
// //                       xmlnsXlink="http://www.w3.org/1999/xlink"
// //                       width="24px"
// //                       height="24px"
// //                       viewBox="0 0 24 24"
// //                       version="1.1"
// //                     >
// //                       <g
// //                         stroke="none"
// //                         strokeWidth={1}
// //                         fill="none"
// //                         fillRule="evenodd"
// //                       >
// //                         <rect x={0} y={0} width={24} height={24} />
// //                         <path
// //                           d="M13.6855025,18.7082217 C15.9113859,17.8189707 18.682885,17.2495635 22,17 C22,16.9325178 22,13.1012863 22,5.50630526 L21.9999762,5.50630526 C21.9999762,5.23017604 21.7761292,5.00632908 21.5,5.00632908 C21.4957817,5.00632908 21.4915635,5.00638247 21.4873465,5.00648922 C18.658231,5.07811173 15.8291155,5.74261533 13,7 C13,7.04449645 13,10.79246 13,18.2438906 L12.9999854,18.2438906 C12.9999854,18.520041 13.2238496,18.7439052 13.5,18.7439052 C13.5635398,18.7439052 13.6264972,18.7317946 13.6855025,18.7082217 Z"
// //                           fill="#000000"
// //                         />
// //                         <path
// //                           d="M10.3144829,18.7082217 C8.08859955,17.8189707 5.31710038,17.2495635 1.99998542,17 C1.99998542,16.9325178 1.99998542,13.1012863 1.99998542,5.50630526 L2.00000925,5.50630526 C2.00000925,5.23017604 2.22385621,5.00632908 2.49998542,5.00632908 C2.50420375,5.00632908 2.5084219,5.00638247 2.51263888,5.00648922 C5.34175439,5.07811173 8.17086991,5.74261533 10.9999854,7 C10.9999854,7.04449645 10.9999854,10.79246 10.9999854,18.2438906 L11,18.2438906 C11,18.520041 10.7761358,18.7439052 10.4999854,18.7439052 C10.4364457,18.7439052 10.3734882,18.7317946 10.3144829,18.7082217 Z"
// //                           fill="#000000"
// //                           opacity="0.3"
// //                         />
// //                       </g>
// //                     </svg>
// //                   </span>
// //                 </span>
// //                 <h3 className="card-label">Manage Menu</h3>
// //                 {!passcode && (
// //                   <a
// //                     href="javascript:;"
// //                     className="mb-2"
// //                     onClick={() => this.setState({ showPasscodeModal: true })}
// //                   >
// //                     <span className="svg-icon svg-icon-primary svg-icon-2x">
// //                       <svg
// //                         xmlns="http://www.w3.org/2000/svg"
// //                         xmlnsXlink="http://www.w3.org/1999/xlink"
// //                         width="24px"
// //                         height="24px"
// //                         viewBox="0 0 24 24"
// //                         version="1.1"
// //                       >
// //                         <g
// //                           stroke="none"
// //                           strokeWidth={1}
// //                           fill="none"
// //                           fillRule="evenodd"
// //                         >
// //                           <mask fill="white">
// //                             <use xlinkHref="#path-1" />
// //                           </mask>
// //                           <g />
// //                           <path
// //                             d="M15.6274517,4.55882251 L14.4693753,6.2959371 C13.9280401,5.51296885 13.0239252,5 12,5 C10.3431458,5 9,6.34314575 9,8 L9,10 L14,10 L17,10 L18,10 C19.1045695,10 20,10.8954305 20,12 L20,18 C20,19.1045695 19.1045695,20 18,20 L6,20 C4.8954305,20 4,19.1045695 4,18 L4,12 C4,10.8954305 4.8954305,10 6,10 L7,10 L7,8 C7,5.23857625 9.23857625,3 12,3 C13.4280904,3 14.7163444,3.59871093 15.6274517,4.55882251 Z"
// //                             fill="#000000"
// //                           />
// //                         </g>
// //                       </svg>
// //                     </span>
// //                   </a>
// //                 )}
// //               </div>
// //             </div>
// //             <div className="card-body">
// //               {passcode && (
// //                 <div className="form-group category-row">
// //                   <ul
// //                     className="nav nav-primary nav-pills"
// //                     id="category-tabs"
// //                     role="tablist"
// //                   >
// //                     {this._showCategories()}

// //                     <li className="nav-item mt-3 ml-3">
// //                       <button
// //                         type="button"
// //                         className="btn btn-outline-primary w-xs-100"
// //                         onClick={() =>
// //                           this.setState({ showAddCategoryModal: true })
// //                         }
// //                       >
// //                         Add a Category
// //                       </button>
// //                     </li>
// //                   </ul>
// //                 </div>
// //               )}

// //               {/* <div className="row wd-100">
// //                 <div className="col-lg-6">
// //                   <StatsCard
// //                     data={[
// //                       {
// //                         statsInfo: `${Currency.format(stats?.total_earnings)}`,
// //                         title: "Total Revenue",
// //                         icon: (
// //                           <g
// //                             stroke="none"
// //                             strokeWidth={1}
// //                             fill="none"
// //                             fillRule="evenodd"
// //                           >
// //                             <rect x={0} y={0} width={24} height={24} />
// //                             <path
// //                               d="M4.3618034,10.2763932 L4.8618034,9.2763932 C4.94649941,9.10700119 5.11963097,9 5.30901699,9 L15.190983,9 C15.4671254,9 15.690983,9.22385763 15.690983,9.5 C15.690983,9.57762255 15.6729105,9.65417908 15.6381966,9.7236068 L15.1381966,10.7236068 C15.0535006,10.8929988 14.880369,11 14.690983,11 L4.80901699,11 C4.53287462,11 4.30901699,10.7761424 4.30901699,10.5 C4.30901699,10.4223775 4.32708954,10.3458209 4.3618034,10.2763932 Z M14.6381966,13.7236068 L14.1381966,14.7236068 C14.0535006,14.8929988 13.880369,15 13.690983,15 L4.80901699,15 C4.53287462,15 4.30901699,14.7761424 4.30901699,14.5 C4.30901699,14.4223775 4.32708954,14.3458209 4.3618034,14.2763932 L4.8618034,13.2763932 C4.94649941,13.1070012 5.11963097,13 5.30901699,13 L14.190983,13 C14.4671254,13 14.690983,13.2238576 14.690983,13.5 C14.690983,13.5776225 14.6729105,13.6541791 14.6381966,13.7236068 Z"
// //                               fill="#000000"
// //                               opacity="0.3"
// //                             />
// //                             <path
// //                               d="M17.369,7.618 C16.976998,7.08599734 16.4660031,6.69750122 15.836,6.4525 C15.2059968,6.20749878 14.590003,6.085 13.988,6.085 C13.2179962,6.085 12.5180032,6.2249986 11.888,6.505 C11.2579969,6.7850014 10.7155023,7.16999755 10.2605,7.66 C9.80549773,8.15000245 9.45550123,8.72399671 9.2105,9.382 C8.96549878,10.0400033 8.843,10.7539961 8.843,11.524 C8.843,12.3360041 8.96199881,13.0779966 9.2,13.75 C9.43800119,14.4220034 9.7774978,14.9994976 10.2185,15.4825 C10.6595022,15.9655024 11.1879969,16.3399987 11.804,16.606 C12.4200031,16.8720013 13.1129962,17.005 13.883,17.005 C14.681004,17.005 15.3879969,16.8475016 16.004,16.5325 C16.6200031,16.2174984 17.1169981,15.8010026 17.495,15.283 L19.616,16.774 C18.9579967,17.6000041 18.1530048,18.2404977 17.201,18.6955 C16.2489952,19.1505023 15.1360064,19.378 13.862,19.378 C12.6999942,19.378 11.6325049,19.1855019 10.6595,18.8005 C9.68649514,18.4154981 8.8500035,17.8765035 8.15,17.1835 C7.4499965,16.4904965 6.90400196,15.6645048 6.512,14.7055 C6.11999804,13.7464952 5.924,12.6860058 5.924,11.524 C5.924,10.333994 6.13049794,9.25950479 6.5435,8.3005 C6.95650207,7.34149521 7.5234964,6.52600336 8.2445,5.854 C8.96550361,5.18199664 9.8159951,4.66400182 10.796,4.3 C11.7760049,3.93599818 12.8399943,3.754 13.988,3.754 C14.4640024,3.754 14.9609974,3.79949954 15.479,3.8905 C15.9970026,3.98150045 16.4939976,4.12149906 16.97,4.3105 C17.4460024,4.49950095 17.8939979,4.7339986 18.314,5.014 C18.7340021,5.2940014 19.0909985,5.62999804 19.385,6.022 L17.369,7.618 Z"
// //                               fill="#000000"
// //                             />
// //                           </g>
// //                         ),
// //                       },
// //                     ]}
// //                   />
// //                 </div>
// //                 <div className="col-lg-6">
// //                   {" "}
// //                   <StatsCard
// //                     data={[
// //                       {
// //                         statsInfo: `${stats?.sales_count}`,
// //                         title: "Current Orders",
// //                         icon: (
// //                           <g
// //                             stroke="none"
// //                             strokeWidth={1}
// //                             fill="none"
// //                             fillRule="evenodd"
// //                           >
// //                             <rect x={0} y={0} width={24} height={24} />
// //                             <path
// //                               d="M22,17 L22,21 C22,22.1045695 21.1045695,23 20,23 L4,23 C2.8954305,23 2,22.1045695 2,21 L2,17 L6.27924078,17 L6.82339262,18.6324555 C7.09562072,19.4491398 7.8598984,20 8.72075922,20 L15.381966,20 C16.1395101,20 16.8320364,19.5719952 17.1708204,18.8944272 L18.118034,17 L22,17 Z"
// //                               fill="#000000"
// //                             />
// //                             <path
// //                               d="M2.5625,15 L5.92654389,9.01947752 C6.2807805,8.38972356 6.94714834,8 7.66969497,8 L16.330305,8 C17.0528517,8 17.7192195,8.38972356 18.0734561,9.01947752 L21.4375,15 L18.118034,15 C17.3604899,15 16.6679636,15.4280048 16.3291796,16.1055728 L15.381966,18 L8.72075922,18 L8.17660738,16.3675445 C7.90437928,15.5508602 7.1401016,15 6.27924078,15 L2.5625,15 Z"
// //                               fill="#000000"
// //                               opacity="0.3"
// //                             />
// //                             <path
// //                               d="M11.1288761,0.733697713 L11.1288761,2.69017121 L9.12120481,2.69017121 C8.84506244,2.69017121 8.62120481,2.91402884 8.62120481,3.19017121 L8.62120481,4.21346991 C8.62120481,4.48961229 8.84506244,4.71346991 9.12120481,4.71346991 L11.1288761,4.71346991 L11.1288761,6.66994341 C11.1288761,6.94608579 11.3527337,7.16994341 11.6288761,7.16994341 C11.7471877,7.16994341 11.8616664,7.12798964 11.951961,7.05154023 L15.4576222,4.08341738 C15.6683723,3.90498251 15.6945689,3.58948575 15.5161341,3.37873564 C15.4982803,3.35764848 15.4787093,3.33807751 15.4576222,3.32022374 L11.951961,0.352100892 C11.7412109,0.173666017 11.4257142,0.199862688 11.2472793,0.410612793 C11.1708299,0.500907473 11.1288761,0.615386087 11.1288761,0.733697713 Z"
// //                               fill="#000000"
// //                               fillRule="nonzero"
// //                               transform="translate(11.959697, 3.661508) rotate(-270.000000) translate(-11.959697, -3.661508) "
// //                             />
// //                           </g>
// //                         ),
// //                       },
// //                     ]}
// //                   />
// //                 </div>
// //               </div> */}
// //               <AddCategoryModal
// //                 show={showAddCategoryModal}
// //                 passcode={passcode}
// //                 menuId={menuId}
// //                 onUpdated={() => {
// //                   this.setState(
// //                     {
// //                       passcode,
// //                       showAddCategoryModal: false,
// //                     },

// //                     () => {
// //                       this._getMenu();
// //                     }
// //                   );
// //                 }}
// //                 onHide={() =>
// //                   this.setState({
// //                     showAddCategoryModal: false,
// //                   })
// //                 }
// //               />
// //               {/* {categoryMenuItem && (
// //                 <MenuItemsTable
// //                   menuId={menuId}
// //                   passcode={passcode}
// //                   menuCategoryId={menuCategoryId}
// //                   categoryId={categoryId}
// //                 />
// //               )} */}
// // {/* 
// //               {categoryMenuItem && (
// //   <>
// //     {venueId != null && (
// //       <VenueDepartments
// //         key={`${venueId}-${categoryId}`}
// //         venueId={venueId}
// //         categoryId={categoryId}
// //       />
// //     )}

// //     <MenuItemsTable
// //       menuId={menuId}
// //       passcode={passcode}
// //       menuCategoryId={menuCategoryId}
// //       categoryId={categoryId}
// //     />
// //   </>
// // )} */}





// // {!passcode ? (
// //   <div className="alert alert-info">
// //     Enter your passcode to manage categories and departments.

// //     <button
// //       type="button"
// //       className="btn btn-primary ml-3"
// //       onClick={() => this.setState({ showPasscodeModal: true })}
// //     >
// //       Enter Passcode
// //     </button>
// //   </div>
// // ) : this.state.isMenuDataLoading ? (
// //   <p role="status">Loading menu...</p>
// // ) : !categoryMenuItem ? (
// //   <div className="alert alert-info">
// //     Select or add a category to manage its departments.
// //   </div>
// // ) : (
// //   <>
// //     {venueId == null ? (
// //       <div className="alert alert-warning">
// //         The venue ID is missing. Pass the actual venueId to ManageMenu
// //         to load the department form.
// //       </div>
// //     ) : (
// //       <VenueDepartments
// //         key={`${venueId}-${categoryId}`}
// //         venueId={venueId}
// //         categoryId={categoryId}
// //       />
// //     )}

// //     <MenuItemsTable
// //       menuId={menuId}
// //       passcode={passcode}
// //       menuCategoryId={menuCategoryId}
// //       categoryId={categoryId}
// //     />
// //   </>
// // )}





// //               {!passcode && (
// //                 <PasscodeModal
// //                   show={showPasscodeModal}
// //                   onHide={() =>
// //                     this.setState({
// //                       showPasscodeModal: false,
// //                     })
// //                   }
// //                   onUpdated={(passcode) => {
// //                     this.setState(
// //                       {
// //                         passcode,
// //                       },
// //                       () => {
// //                         this._getMenu();
// //                       }
// //                     );
// //                   }}
// //                 />
// //               )}
// //             </div>
// //           </div>
// //         </div>
// //       </>
// //     );
// //   }
// // }








// import React, { Component } from "react";

// import Backend from "../utils/Backend";
// import Notify from "../utils/Notify";
// import General from "../utils/General";
// import Event from "../utils/Event";

// import MenuItemsTable from "./components/tables/MenuItemsTableV2";
// import AddCategoryModal from "./components/modals/AddCategoryModal";
// import PasscodeModal from "./components/modals/PasscodeModal";
// import VenueDepartments from "./components/venuedepartment/venuedepartments";

// import { PASSCODE_ICON_UPDATED } from "../constants/Events";

// export default class ManageMenu extends Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       data: null,
//       passcode: null,
//       selectedCategoryItem: null,
//       isMenuDataLoading: false,
//       showAddCategoryModal: false,
//       showPasscodeModal: false,
//       menuError: "",
//     };

//     this.menuRequestId = 0;
//     this.unmounted = false;
//   }

//   componentDidMount() {
//     let passcode = null;

//     try {
//       passcode = JSON.parse(sessionStorage.getItem("passcodeKey"));
//     } catch {
//       // An invalid stored value should not prevent the page from rendering.
//     }

//     this.setState({ passcode }, () => this._getMenu());
//   }

//   componentDidUpdate(previousProps) {
//     const previousMenuId = previousProps.match?.params?.menuId;
//     const currentMenuId = this.props.match?.params?.menuId;

//     if (previousMenuId !== currentMenuId) {
//       this.setState(
//         {
//           data: null,
//           selectedCategoryItem: null,
//           showAddCategoryModal: false,
//         },
//         () => this._getMenu()
//       );
//     }
//   }

//   componentWillUnmount() {
//     this.unmounted = true;
//     this.menuRequestId += 1;
//   }

//   onClickTabItem(categoryId) {
//     this.setState({ selectedCategoryItem: categoryId });
//   }

//   async _getMenu() {
//     const requestId = ++this.menuRequestId;
//     const menuId = this.props.match?.params?.menuId;
//     const { passcode } = this.state;

//     if (!passcode) {
//       this.setState({
//         data: null,
//         selectedCategoryItem: null,
//         isMenuDataLoading: false,
//         menuError: "",
//       });
//       return;
//     }

//     if (menuId == null || menuId === "") {
//       this.setState({
//         isMenuDataLoading: false,
//         menuError: "The menu ID is missing from the route.",
//       });
//       return;
//     }

//     this.setState({
//       isMenuDataLoading: true,
//       menuError: "",
//     });

//     try {
//       const data = await Backend.getMenu(menuId, passcode);

//       if (this.unmounted || requestId !== this.menuRequestId) {
//         return;
//       }

//       const categories = (data?.menu_categories || []).filter(
//         (item) => item?.category?.id != null
//       );

//       try {
//         sessionStorage.setItem("passcodeKey", JSON.stringify(passcode));
//       } catch {
//         // The menu can still be used if session storage is unavailable.
//       }

//       this.setState((previousState) => {
//         const selectedCategory = categories.find(
//           (item) =>
//             String(item.category.id) ===
//             String(previousState.selectedCategoryItem)
//         );

//         return {
//           data,
//           passcode,
//           isMenuDataLoading: false,
//           menuError: "",
//           showPasscodeModal: false,
//           selectedCategoryItem:
//             selectedCategory?.category?.id ??
//             categories[0]?.category?.id ??
//             null,
//         };
//       });

//       Event.emit(PASSCODE_ICON_UPDATED, passcode);
//     } catch (error) {
//       if (this.unmounted || requestId !== this.menuRequestId) {
//         return;
//       }

//       const message = error?.message || "Unable to load the menu.";

//       this.setState({
//         isMenuDataLoading: false,
//         menuError: message,
//       });

//       Notify.error(message);
//     }
//   }

//   _showCategories() {
//     const { data, selectedCategoryItem } = this.state;

//     return (data?.menu_categories || []).map((categoryItem) => {
//       const category = categoryItem?.category;

//       if (category?.id == null) {
//         return null;
//       }

//       const active =
//         String(selectedCategoryItem) === String(category.id);

//       return (
//         <li className="nav-item mt-3" key={categoryItem.id ?? category.id}>
//           <button
//             type="button"
//             className={`nav-link ${active ? "active" : ""}`}
//             aria-pressed={active}
//             onClick={() => this.onClickTabItem(category.id)}
//           >
//             <span className="nav-text">
//               {General.toTitleCase(category.title || "")}
//             </span>
//           </button>
//         </li>
//       );
//     });
//   }

//   render() {
//     const {
//       data,
//       passcode,
//       selectedCategoryItem,
//       isMenuDataLoading,
//       showAddCategoryModal,
//       showPasscodeModal,
//       menuError,
//     } = this.state;

//     const menuId = this.props.match?.params?.menuId;

//     // Use the actual venue ID, not the menu ID.
//     // const venueId =
//     //   this.props.match?.params?.venueId ?? this.props.venueId;

//     const menuVenueId =
//   data?.venue_id ??
//   (typeof data?.venue === "object"
//     ? data?.venue?.id
//     : data?.venue);

// // const menuId = this.props.match?.params?.menuId;

// const venueId =
//   this.props.match?.params?.venueId ??
//   this.props.venueId ??
//   menuId;

// const hasVenueId = venueId != null && venueId !== "";

//     // const hasVenueId = venueId != null && venueId !== "";

//     const categoryMenuItem = (data?.menu_categories || []).find(
//       (item) =>
//         item?.category?.id != null &&
//         String(item.category.id) === String(selectedCategoryItem)
//     );

//     const categoryId = categoryMenuItem?.category?.id;
//     const menuCategoryId = categoryMenuItem?.id;

//     return (
//       <div className="container">
//         <div className="card card-custom gutter-b">
//           <div className="card-header">
//             <div className="card-title">
//               <h3 className="card-label">Manage Menu</h3>
//             </div>

//             <div className="card-toolbar">
//               <button
//                 type="button"
//                 className="btn btn-light-primary"
//                 disabled={isMenuDataLoading}
//                 onClick={() =>
//                   this.setState({ showPasscodeModal: true })
//                 }
//               >
//                 {passcode ? "Change Passcode" : "Enter Passcode"}
//               </button>
//             </div>
//           </div>

//           <div className="card-body">
//             {!passcode ? (
//               <div className="alert alert-info">
//                 Enter your passcode to manage categories and departments.
//               </div>
//             ) : isMenuDataLoading ? (
//               <p role="status">Loading menu...</p>
//             ) : menuError ? (
//               <div className="alert alert-danger" role="alert">
//                 <p>{menuError}</p>

//                 <button
//                   type="button"
//                   className="btn btn-light mr-2"
//                   onClick={() => this._getMenu()}
//                 >
//                   Retry
//                 </button>

//                 <button
//                   type="button"
//                   className="btn btn-light"
//                   onClick={() =>
//                     this.setState({ showPasscodeModal: true })
//                   }
//                 >
//                   Change Passcode
//                 </button>
//               </div>
//             ) : (
//               <>
//                 <div className="form-group category-row">
//                   <ul
//                     className="nav nav-primary nav-pills"
//                     id="category-tabs"
//                   >
//                     {this._showCategories()}

//                     <li className="nav-item mt-3 ml-3">
//                       <button
//                         type="button"
//                         className="btn btn-outline-primary w-xs-100"
//                         onClick={() =>
//                           this.setState({ showAddCategoryModal: true })
//                         }
//                       >
//                         Add a Category
//                       </button>
//                     </li>
//                   </ul>
//                 </div>

//                 {!categoryMenuItem ? (
//                   <div className="alert alert-info">
//                     Add or select a category to manage its departments.
//                   </div>
//                 ) : (
//                   <>
//                     {hasVenueId ? (
//                       <VenueDepartments
//                         key={`${menuId}-${venueId}-${categoryId}`}
//                         venueId={venueId}
//                         categoryId={categoryId}
//                         passcode={passcode}
//                       />
//                     ) : (
//                       <div className="alert alert-warning" role="alert">
//                         The venue ID is missing. Supply venueId through
//                         the route or the ManageMenu props to display
//                         department controls.
//                       </div>
//                     )}

//                     <MenuItemsTable
//                       key={`${menuId}-${menuCategoryId}`}
//                       menuId={menuId}
//                       passcode={passcode}
//                       menuCategoryId={menuCategoryId}
//                       categoryId={categoryId}
//                     />
//                   </>
//                 )}
//               </>
//             )}

//             {/* {passcode && showAddCategoryModal && (
//               <AddCategoryModal
//                 show={showAddCategoryModal}
//                 passcode={passcode}
//                 menuId={menuId}
//                 onUpdated={() => {
//                   this.setState(
//                     { showAddCategoryModal: false },
//                     () => this._getMenu()
//                   );
//                 }}
//                 onHide={() =>
//                   this.setState({ showAddCategoryModal: false })
//                 }
//               />
//             )} */}


//             {passcode &&
//   !isMenuDataLoading &&
//   !menuError &&
//   categoryMenuItem && (
//     <>
//       {hasVenueId && (
//         <VenueDepartments
//           key={`${venueId}-${categoryId}`}
//           venueId={venueId}
//           categoryId={categoryId}
//           categoryTitle={categoryMenuItem.category.title}
//         />
//       )}

//       <MenuItemsTable
//         key={`${menuId}-${menuCategoryId}`}
//         menuId={menuId}
//         passcode={passcode}
//         menuCategoryId={menuCategoryId}
//         categoryId={categoryId}
//       />
//     </>
//   )}

//             <PasscodeModal
//               show={showPasscodeModal}
//               onHide={() =>
//                 this.setState({ showPasscodeModal: false })
//               }
//               onUpdated={(newPasscode) => {
//                 this.setState(
//                   {
//                     passcode: newPasscode,
//                     showPasscodeModal: false,
//                     showAddCategoryModal: false,
//                     data: null,
//                     selectedCategoryItem: null,
//                     menuError: "",
//                   },
//                   () => this._getMenu()
//                 );
//               }}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   }
// }





import React, { Component } from "react";

import Backend from "../utils/Backend";
import Notify from "../utils/Notify";
import General from "../utils/General";
import Event from "../utils/Event";

import MenuItemsTable from "./components/tables/MenuItemsTableV2";
import AddCategoryModal from "./components/modals/AddCategoryModal";
import PasscodeModal from "./components/modals/PasscodeModal";
import VenueDepartments from "./components/venuedepartment/venuedepartments";

import { PASSCODE_ICON_UPDATED } from "../constants/Events";

export default class ManageMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      passcode: null,
      selectedCategoryItem: null,
      isMenuDataLoading: false,
      showAddCategoryModal: false,
      showPasscodeModal: false,
      menuError: "",
    };

    this.menuRequestId = 0;
    this.unmounted = false;
  }

  componentDidMount() {
    this.unmounted = false;

    let passcode = null;

    try {
      passcode = JSON.parse(sessionStorage.getItem("passcodeKey"));
    } catch {
      // Continue without a stored passcode.
    }

    this.setState({ passcode }, () => this._getMenu());
  }

  componentDidUpdate(previousProps) {
    const previousMenuId = previousProps.match?.params?.menuId;
    const currentMenuId = this.props.match?.params?.menuId;

    if (previousMenuId !== currentMenuId) {
      this.setState(
        {
          data: null,
          selectedCategoryItem: null,
          showAddCategoryModal: false,
          menuError: "",
        },
        () => this._getMenu()
      );
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
    this.menuRequestId += 1;
  }

  onClickTabItem(categoryId) {
    this.setState({ selectedCategoryItem: categoryId });
  }

  async _getMenu() {
    const requestId = ++this.menuRequestId;
    const menuId = this.props.match?.params?.menuId;
    const { passcode } = this.state;

    if (!passcode) {
      this.setState({
        data: null,
        selectedCategoryItem: null,
        isMenuDataLoading: false,
        menuError: "",
      });
      return;
    }

    if (menuId == null || menuId === "") {
      this.setState({
        isMenuDataLoading: false,
        menuError: "The menu ID is missing from the route.",
      });
      return;
    }

    this.setState({
      isMenuDataLoading: true,
      menuError: "",
    });

    try {
      const data = await Backend.getMenu(menuId, passcode);

      if (this.unmounted || requestId !== this.menuRequestId) {
        return;
      }

      if (!Array.isArray(data?.menu_categories)) {
        throw new Error("The menu response is missing its categories.");
      }

      const categories = data.menu_categories.filter(
        (item) => item?.category?.id != null
      );

      try {
        sessionStorage.setItem("passcodeKey", JSON.stringify(passcode));
      } catch {
        // The menu still works if session storage is unavailable.
      }

      this.setState((previousState) => {
        const selectedCategory = categories.find(
          (item) =>
            String(item.category.id) ===
            String(previousState.selectedCategoryItem)
        );

        return {
          data,
          passcode,
          isMenuDataLoading: false,
          menuError: "",
          showPasscodeModal: false,
          selectedCategoryItem:
            selectedCategory?.category?.id ??
            categories[0]?.category?.id ??
            null,
        };
      });

      Event.emit(PASSCODE_ICON_UPDATED, passcode);
    } catch (error) {
      if (this.unmounted || requestId !== this.menuRequestId) {
        return;
      }

      const message = error?.message || "Unable to load the menu.";

      this.setState({
        isMenuDataLoading: false,
        menuError: message,
      });

      Notify.error(message);
    }
  }

  _showCategories() {
    const { data, selectedCategoryItem } = this.state;

    return (data?.menu_categories || []).map((categoryItem) => {
      const category = categoryItem?.category;

      if (category?.id == null) {
        return null;
      }

      const active =
        String(selectedCategoryItem) === String(category.id);

      return (
        <li
          className="nav-item mt-3"
          key={categoryItem.id ?? category.id}
        >
          <button
            type="button"
            className={`nav-link ${active ? "active" : ""}`}
            aria-pressed={active}
            onClick={() => this.onClickTabItem(category.id)}
          >
            <span className="nav-text">
              {General.toTitleCase(category.title || "")}
            </span>
          </button>
        </li>
      );
    });
  }

  render() {
    const {
      data,
      passcode,
      selectedCategoryItem,
      isMenuDataLoading,
      showAddCategoryModal,
      showPasscodeModal,
      menuError,
    } = this.state;

    const menuId = this.props.match?.params?.menuId;

    // Your Header builds /menus/:menuId using active_venue,
    // so this route parameter contains the venue ID.
    const venueId =
      this.props.match?.params?.venueId ??
      this.props.venueId ??
      menuId;

    const hasVenueId = venueId != null && venueId !== "";

    const categoryMenuItem = (data?.menu_categories || []).find(
      (item) =>
        item?.category?.id != null &&
        String(item.category.id) === String(selectedCategoryItem)
    );

    const categoryId = categoryMenuItem?.category?.id;
    const categoryTitle = categoryMenuItem?.category?.title;
    const menuCategoryId = categoryMenuItem?.id;

    return (
      <div className="container">
        <div className="card card-custom gutter-b">
          <div className="card-header">
            <div className="card-title">
              <h3 className="card-label">Manage Menu</h3>
            </div>

            <div className="card-toolbar">
              <button
                type="button"
                className="btn btn-light-primary"
                disabled={isMenuDataLoading}
                onClick={() =>
                  this.setState({ showPasscodeModal: true })
                }
              >
                {passcode ? "Change Passcode" : "Enter Passcode"}
              </button>
            </div>
          </div>

          <div className="card-body">
            {!passcode ? (
              <div className="alert alert-info">
                Enter your passcode to manage categories and their
                opening hours.
              </div>
            ) : isMenuDataLoading ? (
              <p role="status">Loading menu...</p>
            ) : menuError ? (
              <div className="alert alert-danger" role="alert">
                <p>{menuError}</p>

                <button
                  type="button"
                  className="btn btn-light mr-2"
                  onClick={() => this._getMenu()}
                >
                  Retry
                </button>

                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() =>
                    this.setState({ showPasscodeModal: true })
                  }
                >
                  Change Passcode
                </button>
              </div>
            ) : (
              <>
                <div className="form-group category-row">
                  <ul
                    className="nav nav-primary nav-pills"
                    id="category-tabs"
                  >
                    {this._showCategories()}

                    <li className="nav-item mt-3 ml-3">
                      <button
                        type="button"
                        className="btn btn-outline-primary w-xs-100"
                        onClick={() =>
                          this.setState({
                            showAddCategoryModal: true,
                          })
                        }
                      >
                        Add a Category
                      </button>
                    </li>
                  </ul>
                </div>

                {!categoryMenuItem ? (
                  <div className="alert alert-info">
                    Add or select a category to manage its opening
                    hours and menu items.
                  </div>
                ) : (
                  <>
                    {hasVenueId ? (
                      <VenueDepartments
                        key={`${menuId}-${venueId}-${categoryId}`}
                        venueId={venueId}
                        categoryId={categoryId}
                        categoryTitle={categoryTitle}
                        passcode={passcode}
                      />
                    ) : (
                      <div
                        className="alert alert-warning"
                        role="alert"
                      >
                        Select a venue to manage category opening
                        hours.
                      </div>
                    )}

                    <MenuItemsTable
                      key={`${menuId}-${menuCategoryId}`}
                      menuId={menuId}
                      passcode={passcode}
                      menuCategoryId={menuCategoryId}
                      categoryId={categoryId}
                    />
                  </>
                )}
              </>
            )}

            {passcode && showAddCategoryModal && (
              <AddCategoryModal
                show={showAddCategoryModal}
                passcode={passcode}
                menuId={menuId}
                onUpdated={() => {
                  this.setState(
                    { showAddCategoryModal: false },
                    () => this._getMenu()
                  );
                }}
                onHide={() =>
                  this.setState({
                    showAddCategoryModal: false,
                  })
                }
              />
            )}

            <PasscodeModal
              show={showPasscodeModal}
              onHide={() =>
                this.setState({ showPasscodeModal: false })
              }
              onUpdated={(newPasscode) => {
                this.setState(
                  {
                    passcode: newPasscode,
                    showPasscodeModal: false,
                    showAddCategoryModal: false,
                    data: null,
                    selectedCategoryItem: null,
                    menuError: "",
                  },
                  () => this._getMenu()
                );
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}